import React, { Component } from 'react';
import { fetchAboutMe } from '../services';
import EnhancedUserProfile from './EnhancedUserProfile';
import Loader from '../Loader';

class EditProfile extends Component {

  state = {
    user: '',
    loading: true
  }

  async componentDidMount() {
    const response = await fetchAboutMe();

    this.setState(prevState => ({
      user: response.data.about,
      loading: false
    }))
  }

  render() {

    if(this.state.loading == true) {
      return (
        <Loader />
      )
    }

    
    const { user } = this.state;
    
    let children = user.children.map((child, index) => {
      return { _id: child._id, name: child.name, dob: new Date(child.dob), gender: child.gender}
    })

    console.log(user);
    return (
      <EnhancedUserProfile 
        fullName={user.name}
        email={user.email}
        phone={user.mobile}
        dob={new Date(user.dob)}
        gender={user.gender}
        children={children}
        profilePicture={user.image}
        contacts={user.contacts}
        lifeStage={user.lifeStage}
      />
    )
  }
}


export default EditProfile


// WEBPACK FOOTER //
// ./src/views/Account/EditProfile.js